import * as React from "react";
import ISelectOption from "../ComponentsTypes";
import {StyleRulesCallback, WithStyles, withStyles} from "@material-ui/core";
import Icon from "../../components/Icon/Icon";


interface IProps  {
    optionPros: ISelectOption
    isChecked: boolean
}

interface ILocalState {}

const styles: StyleRulesCallback = ({ breakpoints, palette }) => ({
    optionContainer: {
        borderRadius: 10,
        boxShadow: "0 2px 4px 0 rgba(226, 230, 236, 0.5)",
        backgroundColor: "#ffffff",
        padding: ".7em",
        margin: "1em 0",
        fontSize: 15,
        fontWeight: 500,
        color: "#2f3033",
        display: "flex"
    },
    checkmarkContainer: {
        marginRight: ".5em"
    },
    optionWithFreeText: {
        marginBottom: "-.7em",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    },
    comment: {
        fontSize: 13,
        fontWeight: 500,
        color:"#9ca6ad",
    }
});

@(withStyles(styles) as any)
export default class FormMultipleSelectOption extends React.Component<
    IProps & Partial<WithStyles<any>>
    > {
    public state: ILocalState = {};

    public render() {
        return (
            <>
                {this.renderOption()}
            </>);
    }

    private renderOption = () => {
        const {optionPros, classes, isChecked} = this.props;
        return <>
            <div className={classes!.optionContainer + (isChecked && optionPros.label === "Other"? " " + classes!.optionWithFreeText : "")}>
                <div className={classes!.checkmarkContainer}><Icon icon={isChecked? 'checkedCheckbox' : 'checkbox'}/></div>
                <div>{optionPros.label}</div>
            </div>
            {this.renderCommentIfNeeded()}
        </>
    }

    private renderCommentIfNeeded = () => {
        const {optionPros, classes} = this.props;
        if(optionPros.value === "Payroll") {
            return <div className={classes!.comment}>To be eligible for forgiveness, at least 75% of your loan must be used to cover payroll costs</div>
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/components/FormMultipleSelect/FormMultipleSelectOption.tsx